import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import { Avatar, Grid, Stack, Typography } from "@mui/material";
import { memo } from "react";
import type { Dashboard } from "../../../../../api/types/dashboardsTypes";
import { FilterComponentType, ReferenceDateType, WidgetType } from "../../../../../api/types/dashboardsTypes";
import { useDashboardContext } from "../../contexts/DashboardContext";
import type { TileObjectFilter } from "../../models/TileObject";
import { defaultFilterWidgetSize, generateWidgetId } from "./generateWidgetId";
import { reportItemSx } from "./reportItemSx";

const NewFilterWidget = memo(function NewFilterWidget() {
  const { dashboard, addNewTile } = useDashboardContext();

  const onNewFilterWidget = () => {
    if (!dashboard) {
      return;
    }
    const newTile = createNewFilterTile(dashboard);
    addNewTile(newTile);
  };

  if (!dashboard) {
    return null;
  }

  return (
    <Grid
      sx={{ ...reportItemSx, cursor: "pointer" }}
      className="droppable-element"
      draggable={true}
      data-type="filter"
      onDragStart={(e) => handleDragStart(e, createNewFilterTile(dashboard))}
    >
      <Avatar sx={{ width: 32, height: 32, backgroundColor: "action.hover", borderRadius: 1 }}>
        <FilterListRoundedIcon />
      </Avatar>
      <Stack onClick={onNewFilterWidget} direction="column" sx={{ cursor: "pointer" }}>
        <Typography variant="body1">Filter </Typography>
        <Typography variant="caption" color="textSecondary">
          Create a filter widget
        </Typography>
      </Stack>
    </Grid>
  );
});

export default NewFilterWidget;

function createNewFilterTile(dashboard: Dashboard) {
  const id = generateWidgetId();
  const newTile: TileObjectFilter = {
    id,
    isInitialized: true,
    isLoaded: false,
    item: {
      tileId: id,

      location: {
        row: 0,
        column: 0,
        width: defaultFilterWidgetSize.width,
        height: defaultFilterWidgetSize.height,
      },
      widget: {
        type: WidgetType.Filter,
        widgetId: id,
        tileId: id,
        clientCode: dashboard.clientCode,
        dashboardId: dashboard.dashboardId,
        nameUserInput: "New Filter",
        createdBy: "",
        emailCreatedBy: "",
        modifiedBy: "",
        emailModifiedBy: "",
        isDraft: true,
        etag: "",
        componentType: FilterComponentType.Dropdown,
        singleSelect: false,
        defaultValue: [],
        referenceDate: ReferenceDateType.ThisMonth,
      },
    },
  };
  return newTile;
}

const handleDragStart = (e: React.DragEvent, tile: TileObjectFilter) => {
  e.dataTransfer.setData("application/json", JSON.stringify(tile));
  e.dataTransfer.setData(WidgetType.Filter.toLowerCase(), "");
};
